import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {FieldService} from '../../services/FieldService';
import {Checkbox} from 'primeng/checkbox';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-multiple-selection',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox,
    Button,
    InputText
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox binary="true" [(ngModel)]="field.keep_open"/>
        <label>{{ Yii.t('be_forms', 'Keep Open') }}</label>
      </div>
    </div>

    @if (fieldsvc.ShowAddOptions(field)) {
      <div class="form-row">
        <label>{{ Yii.t('app', 'Field Options:') }}</label>
        <div>
          @for (option of field.field_options; track option.option_id) {
            <div class="flex-row gap-4px flex-align-center" style="margin-bottom: 4px">
              <span class="text-danger">*</span>
              <input
                pInputText
                type="text"
                [(ngModel)]="option.option_title"
                [placeholder]="(option.option_title) ? option.option_title : 'Option-' + (option.option_id + 1)"
                (change)="fieldsvc.OnFieldChanged.emit(field)"
                style="width: 70%;">
              @if (field.calculate_by_additional_val && (field.field_type === 'radio' || field.field_type === 'dropdown')) {
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="option.option_additional_value"
                  placeholder="Numeric Val"
                  (change)="fieldsvc.OnFieldChanged.emit(field)"
                  style="width: 10%;"/>
              }
              @if (!option.predefined) {
                <p-button
                  size="small"
                  icon="fa fa-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="fieldsvc.DeleteOption(field, option)"
                />
              }
              <span class="label label-inverse">{{ Yii.t('app', 'Value:') }}{{ option.option_value }}
                ;&nbsp; id= {{ option.option_id }}</span>
            </div>
          }
          <p-button
            (click)="fieldsvc.AddOption(field)"
            [label]="Yii.t('app', 'Add Option')"
            icon="fa fa-plus"
            size="small"
          />
        </div>
      </div>
    }
  `
})
export class FieldMultipleSelection {
  Yii = Yii;
  @Input() field: any;

  constructor(public fieldsvc: FieldService) {
  }
}
